export function format(value, decimalPlaces = 0, options) {
  const defaults = { maximumFractionDigits: decimalPlaces }
  return value.toLocaleString(Object.assign(defaults, options))
}
